import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface RemoveBannerItemTableUseCase {
    invoke: (bannerId : number) => Promise<boolean>;
  }
  
  export class RemoveBannerItemTable implements RemoveBannerItemTableUseCase {
    private repo: OffersPromoRepository;
    constructor(_repo: OffersPromoRepository) {
      this.repo = _repo;
    }
  
    async invoke(bannerId : number){
       
        if(!bannerId){
            throw new Error(
                "Ha ocurrido un error!"
              );
        }
         
        const deleted  = await this.repo.removeBannerItemTable(bannerId);
        return deleted;
    }
  }